var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancellationCalendarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "free_cancellation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.965 14.8125H3.3075V7.3125H13.8075V10.5975L15.3075 9.0975V4.3125C15.3075 3.4875 14.6325 2.8125 13.8075 2.8125H13.0575V1.3125H11.5575V2.8125H5.5575V1.3125H4.0575V2.8125H3.3075C2.475 2.8125 1.815 3.4875 1.815 4.3125L1.8075 14.8125C1.8075 15.6375 2.475 16.3125 3.3075 16.3125H9.465L7.965 14.8125ZM3.3075 4.3125H13.8075V5.8125H3.3075V4.3125ZM11.9625 16.6875L9.3075 14.0325L10.365 12.975L11.955 14.565L15.135 11.385L16.1925 12.4425L11.9625 16.6875ZM7.365 10.3125L8.5575 11.505L7.5 12.5625L6.3075 11.37L5.115 12.5625L4.0575 11.505L5.25 10.3125L4.0575 9.12L5.115 8.0625L6.3075 9.255L7.5 8.0625L8.5575 9.12L7.365 10.3125Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellationCalendarWhite);
export default __webpack_public_path__ + "static/media/cancellation_calendar_white.a4d0e67b315ba864f4ba92c69242b9a7.svg";
export { ForwardRef as ReactComponent };